import qs from "qs";

export class RecommendPackageClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/recommend_packages`;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}${queryString}`;
    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getAllPackages() {
    const url = `${this.baseURL}/packages`;
    const response = await this.httpClient.request("get", url);

    return response;
  }

  async listAllType(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/v2${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async put(id, params) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  async getRequestPackage(params) {
    const query = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/request/package${query}`;
    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getRequestPackageDetail(id, params) {
    const query = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/request/package/detail/${id}${query}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async deleteRequestProjectPackage({ projectId, packageId }) {
    const url = `${this.baseURL}/request/project/${projectId}/package/${packageId}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  async getOrder() {
    const url = `${this.baseURL}/order`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async postOrder(data) {
    const url = `${this.baseURL}/order`;

    const response = await this.httpClient.request("post", url, { data });

    return response;
  }

  async getRegistrationFormsReport(id, query) {
    const queryParams = qs.stringify(query, { addQueryPrefix: true });
    const url = `${this.baseURL}/${id}/registration_forms/report${queryParams}`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }

  async getReport(id) {
    const url = `${this.baseURL}/${id}/active_subscribers/report`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }

  async getLocalization(id, language) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url, {
      headers: { "x-accept-language": language }
    });

    return response;
  }

  async putLocalization(id, params, language) {
    const url = `${this.baseURL}/${id}/translation`;

    const response = await this.httpClient.request("put", url, {
      data: params,
      headers: { "x-accept-language": language }
    });

    return response;
  }

  async getLanguage(id, language) {
    const url = `${this.baseURL}/${id}/language`;

    const response = await this.httpClient.request("get", url, {
      headers: { "x-accept-language": language }
    });

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/subscriptions/recommend_packages.js